export const siteInfo = {
  name: '17c.com',
  tagline: '安全·稳定·流畅 — 您值得信赖的访问平台',
  description: '17c.com致力于为用户提供最新官方访问地址、安全入口及完整使用指南。无论您是新用户还是老用户，都能在这里获得稳定流畅的访问体验。',
  officialUrl: 'https://17c.com',
  email: 'support@17c.com',
  phone: '400-000-1700',
  address: '中国广东省深圳市南山区科技园南路17号',
  workingHours: '周一至周日 9:00 - 22:00',
  socialMedia: {
    weibo: 'https://weibo.com/17c',
    wechat: '17c_com',
    qq: '800017000',
  },
  stats: {
    totalUsers: '580万+',
    dailyVisits: '120万+',
    yearsOnline: '8',
    satisfactionRate: '99.7%',
  },
};